import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import {
    SubmittedProblemRepository,
    RequestGetSubmittedProblemsPayload,
    RequestGetChallengeTemplateProblemListPayload,
} from "@/entities/submitted-problems/domain/repository";
import type { GetStudentSubmittedProblemsResponseDto } from "@/entities/submitted-problems/domain/dtos";

@singleton()
export default class SubmittedProblemsRepositoryImpl implements SubmittedProblemRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    /** @description 챌린지 템플릿 목록 조회 */
    getStudentSubmittedProblems = async (request: RequestGetSubmittedProblemsPayload) => {
        let url = `/v1/student-submitted-problems?`;

        if (request.keyword) {
            url += `keyword=${request.keyword}&`;
        }

        if (request.studentId) {
            url += `studentId=${request.studentId}&`;
        }

        if (request.academyId) {
            url += `academyId=${request.academyId}&`;
        }

        if (request.classId) {
            url += `classId=${request.classId}&`;
        }

        if (request.semesterId) {
            if (Array.isArray(request.semesterId)) {
                request.semesterId.forEach((semesterId) => {
                    url += `semesterId=${semesterId}&`;
                });
            } else {
                url += `semesterId=${request.semesterId}&`;
            }
        }

        if (request.from) {
            url += `from=${request.from}&`;
        }

        if (request.to) {
            url += `to=${request.to}&`;
        }

        if ("fromWrongCount" in request) {
            url += `fromWrongCount=${request.fromWrongCount}&`;
        }

        if ("toWrongCount" in request) {
            url += `toWrongCount=${request.toWrongCount}&`;
        }

        url += `size=${request.size}&`;

        if (request.nextToken) {
            url += `nextToken=${request.nextToken}`;
        }

        const response = await this.server.get<GetStudentSubmittedProblemsResponseDto>(url);

        return response;
    };

    /**
     * @description 챌린지 템플릿 문제 목록 조회
     * @param {RequestGetChallengeTemplateProblemListPayload} request
     * @returns {Promise<GetStudentSubmittedProblemsResponseDto>}
     */
    getChallengeTemplateProblmes = async (
        request: RequestGetChallengeTemplateProblemListPayload,
    ) => {
        let url = `/v1/student-submitted-problems?`;

        if (request.studentId) {
            url += `studentId=${request.studentId}&`;
        }

        if (request.problemIds) {
            if (Array.isArray(request.problemIds)) {
                request.problemIds.forEach((problemId) => {
                    url += `problemId=${problemId}&`;
                });
            } else {
                url += `problemId=${request.problemIds}&`;
            }
        }

        url += `size=${request.size}&`;

        if (request.nextToken) {
            url += `nextToken=${request.nextToken}`;
        }

        const response = await this.server.get<GetStudentSubmittedProblemsResponseDto>(url);

        return response;
    };
}
